import React from 'react';
import { IP55ProductComparePage } from '~/lib/data-contract';
import { ProductComparePage } from '$features/product-compare/product-compare-page';
import { StyledComparePage } from './style';

type P55ProductComparePageProps = IP55ProductComparePage;

export const P55ProductComparePage = ({
                                          products = [],
                                      }: P55ProductComparePageProps) => {
    return (
        <StyledComparePage>
            <ProductComparePage products={products} />
        </StyledComparePage>
    );
};

export default P55ProductComparePage;